<template>
  <v-container fluid>
    <v-layout class="mb-5" align-start justify-left wrap>
      <v-flex>
        <transaction-filter-view :fitler="filterParams.clone()" @change="onFilterUpdated"></transaction-filter-view>
      </v-flex>
    </v-layout>
    <transaction-list
      :filter="filterParams"
      showReport
      @saved="onTransactionSaved"
      @canceled="onTransactionCanceled"
      :refetch.sync="refetch"
    ></transaction-list>

    <div>
      <v-snackbar
        v-model="showCreatedMsg"
        top right
      >
        Transaction Created!
        <v-btn dark text @click="showCreatedMsg = false">Close</v-btn>
      </v-snackbar>
      <v-dialog v-model="showCreateDailog" fullscreen>
        <template v-slot:activator="{ on }"></template>
        <create-transaction
          @created="onTransactionCreated"
          @saved="onTransactionSaved"
          :transaction="transactionDraft"
          v-model="showCreateDailog"
        ></create-transaction>
      </v-dialog>
      <v-dialog v-model="showTagCreateDailog" fullscreen>
        <template v-slot:activator="{ on }"></template>
        <create-tag @created="showTagCreateDailog=false" v-model="showTagCreateDailog"></create-tag>
      </v-dialog>
      <v-dialog v-model="showCategoryCreateDailog" fullscreen>
        <template v-slot:activator="{ on }"></template>
        <create-category
          @created="showCategoryCreateDailog=false"
          v-model="showCategoryCreateDailog"
        ></create-category>
      </v-dialog>
      <v-speed-dial v-model="speeddail" bottom right fixed>
        <template v-slot:activator>
          <v-btn v-model="speeddail" color="blue darken-2" dark fab>
            <v-icon v-if="speeddail">close</v-icon>
            <v-icon v-else>add</v-icon>
          </v-btn>
        </template>
        <v-btn fab dark small color="green" :to="{name: 'transactions-create'}">
          <v-icon>mdi-playlist-plus</v-icon>
        </v-btn>
        <v-btn fab dark small color="green" @click="showCreateDailog=true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn fab dark small color="green" @click="showTagCreateDailog=true">
          <v-icon>tag</v-icon>
        </v-btn>
        <v-btn fab dark small color="indigo" @click="showCategoryCreateDailog=true">
          <v-icon>category</v-icon>
        </v-btn>
      </v-speed-dial>
    </div>
  </v-container>
</template>
<script>
import { DataState } from "@/state";
import { Transaction, TransactionFilter } from "@/models/transaction";
import CreateTransaction from "@/components/CreateTransaction";
import TransactionFilterView from "@/components/TransactionFilter";
import TransactionEditCat from "@/components/TransactionEditCat";
import TransactionItem from "@/components/TransactionItem";
import TransactionList from "@/components/TransactionList"
import CreateTag from "@/components/CreateTag";
import CreateCategory from "@/components/CreateCategory";

export default {
  components: {
    CreateTag,
    CreateCategory,
    TransactionEditCat: TransactionEditCat,
    CreateTransaction: CreateTransaction,
    TransactionFilterView: TransactionFilterView,
    TransactionItem: TransactionItem,
    TransactionList,
  },
  data() {
    return {
      transactionDraft: Transaction.newEmpty(),
      filterParams: TransactionFilter.fromCache(),
      showCreateDailog: false,
      showTagCreateDailog: false,
      showCategoryCreateDailog: false,
      speeddail: false,
      createState: DataState.newLoading(),
      refetch: false,
      showCreatedMsg: false,
    };
  },
  computed: {
    isDataLoading () {
      return this.state && this.state.isLoading()
    }
  },
  mounted() {
    this.onLoaded();
  },

  methods: {
    onLoaded() {
    },

    showDailog() {
      this.transactionDraft = Transaction.newEmpty();
      this.showCreateDailog = true;
    },

    onFilterUpdated (updatedFilter) {
      this.filterParams.update(updatedFilter)
    },

    onTransactionCreated(transaction) {
      this.refetch = true
      this.showCreateDailog = false
      this.showCreatedMsg = true
    },

    onTransactionSaved(transaction, gonext) {
    },

    onTransactionCanceled(transaction, gonext) {
    }
  }
};
</script>
